import { SVGProps } from 'react';

import { COLORS } from '../../../theme/colors';
import { styleConfigs } from '../../resources/styleConfigs';

interface IXIconProps extends SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
  color?: string;
}

const XIcon = ({
  width = styleConfigs.dimensions.width36,
  height = styleConfigs.dimensions.height36,
  color = COLORS.mistBlue,
  ...props
}: IXIconProps): JSX.Element => (
  <svg
    aria-hidden="true"
    focusable="false"
    width={width}
    height={height}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.1149 18L26.5649 11.565C27.1531 10.9769 27.1531 10.0232 26.5649 9.43503C25.9767 8.84685 25.0231 8.84685 24.4349 9.43503L17.9999 15.885L11.5649 9.43503C10.9767 8.84685 10.0231 8.84685 9.43491 9.43503C8.84673 10.0232 8.84673 10.9769 9.43491 11.565L15.8849 18L9.43491 24.435C9.15094 24.7167 8.99121 25.1001 8.99121 25.5C8.99121 25.9 9.15094 26.2834 9.43491 26.565C9.71656 26.849 10.1 27.0087 10.4999 27.0087C10.8999 27.0087 11.2833 26.849 11.5649 26.565L17.9999 20.115L24.4349 26.565C24.7166 26.849 25.1 27.0087 25.4999 27.0087C25.8999 27.0087 26.2833 26.849 26.5649 26.565C26.8489 26.2834 27.0086 25.9 27.0086 25.5C27.0086 25.1001 26.8489 24.7167 26.5649 24.435L20.1149 18Z"
      fill={color}
    />
  </svg>
);

export default XIcon;
